export const REGION_CENTERS: Record<string, { lat: number; lng: number; zoom: number }> = {
  // Slovakia
  "Bratislavský kraj": {lat: 48.15, lng: 17.11, zoom: 10},
  "Trnavský kraj": {lat: 48.38, lng: 17.59, zoom: 10},
  "Trenčiansky kraj": {lat: 48.89, lng: 18.04, zoom: 10},
  "Nitriansky kraj": {lat: 48.31, lng: 18.09, zoom: 10},
  "Žilinský kraj": {lat: 49.22, lng: 18.74, zoom: 10},
  "Banskobystrický kraj": {lat: 48.74, lng: 19.15, zoom: 9},
  "Prešovský kraj": {lat: 49.00, lng: 21.24, zoom: 9},
  "Košický kraj": {lat: 48.72, lng: 21.26, zoom: 10},
  // Czech Republic
  "Praha": {lat: 50.08, lng: 14.44, zoom: 11},
  "Středočeský kraj": {lat: 49.95, lng: 14.65, zoom: 9},
  "Jihočeský kraj": {lat: 49.05, lng: 14.47, zoom: 9},
  "Plzeňský kraj": {lat: 49.74, lng: 13.37, zoom: 9},
  "Karlovarský kraj": {lat: 50.23, lng: 12.87, zoom: 10},
  "Ústecký kraj": {lat: 50.66, lng: 14.03, zoom: 9},
  "Liberecký kraj": {lat: 50.77, lng: 15.06, zoom: 10},
  "Královéhradecký kraj": {lat: 50.21, lng: 15.83, zoom: 9},
  "Pardubický kraj": {lat: 50.03, lng: 15.78, zoom: 9},
  "Vysočina": {lat: 49.40, lng: 15.59, zoom: 9},
  "Jihomoravský kraj": {lat: 49.20, lng: 16.61, zoom: 9},
  "Olomoucký kraj": {lat: 49.59, lng: 17.25, zoom: 9},
  "Zlínský kraj": {lat: 49.23, lng: 17.67, zoom: 10},
  "Moravskoslezský kraj": {lat: 49.82, lng: 18.26, zoom: 9},
};

// Default map center: between Slovakia and Czech Republic
export const DEFAULT_CENTER = {lat: 49.0, lng: 17.5};
export const DEFAULT_ZOOM = 7;
